<div class="users-list">

  <div class="label info" [ngClass]="{'green': showLabelCase === 'add' || showLabelCase === 'edit',
       'yellow': showLabelCase === 'delete' || showLabelCase === 'deletefailed'}" *ngIf="showLabel">
    <p *ngIf="showLabelCase === 'add'">
      user was added successfully!
    </p>
    <p *ngIf="showLabelCase === 'edit'">
      user was updated successfully!
    </p>
    <p *ngIf="showLabelCase === 'delete'">
      user {{deletedUser.firstName}} {{deletedUser.lastName}} ({{deletedUser.emailAddress}}) was deleted successfully!
    </p>
    <p *ngIf="showLabelCase === 'deletefailed'">
      {{deleteFailedReason}}
    </p>
    <span class="close-icon black" [routerLink]="['/admin/users']"
          (click)="showLabel = false"></span>
  </div>

  <h2>
    all users
    <span class="add" [routerLink]="['/admin/users/add']">add user</span>
  </h2>

  <div class="table-helper box-shadow">
    <table class="table-list">
      <thead>
        <tr>
          <td class="filter" [ngClass]="{'selected': usersFilter === 'firstName', 'desc': isColumnDescending('firstName')}"
              (click)="sortUsers('firstName')">
            <span>name</span>
          </td>
          <td class="filter" [ngClass]="{'selected': usersFilter === 'email', 'desc': isColumnDescending('email')}"
              (click)="sortUsers('email')">
            <span>email</span>
          </td>
          <td class="filter" [ngClass]="{'selected': usersFilter === 'role', 'desc': isColumnDescending('role')}"
              (click)="sortUsers('role')">
            <span>role</span>
          </td>
          <td>
            <!--<span>Action</span>-->
          </td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td class="link" routerLink="/admin/users/edit/{{user.id}}">
            {{user.firstName}} {{user.lastName}}
          </td>
          <td>{{user.emailAddress}}</td>
          <td>{{user.role?.name || 'Unknown role'}}</td>
          <td class="link" [ngClass]="{'disabled': user.id === 1}" (click)="open(user.id)">
            delete
          </td>
        </tr>
      </tbody>
    </table>
  </div>

    <kendo-dialog *ngIf="opened"  (close)="close()">
        <kendo-dialog-titlebar>
            <div style="font-size: 18px; line-height: 1.3em;">
              <span class="k-icon k-i-warning k-icon-md"></span> delete user?
            </div>
          </kendo-dialog-titlebar>
      <p style="margin: 30px; text-align: center;">
        Are you sure you want to delete the user?
      </p>
      <kendo-dialog-actions>
        <button kendoButton  class="kendo-dialog-button" (click)="close()" role="button">No</button>
        <button kendoButton class="kendo-dialog-button" (click)="confirmDelete()">Yes</button>
      </kendo-dialog-actions>
    </kendo-dialog>


</div>
